import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent"

const accountID = import.meta.env.VITE_NEWRELIC_ACCOUNT_ID ?? ""
const trustKey = import.meta.env.VITE_NEWRELIC_TRUST_KEY ?? ""
const agentID = import.meta.env.VITE_NEWRELIC_AGENT_ID ?? ""
const licenseKey = import.meta.env.VITE_NEWRELIC_LICENSE_KEY ?? ""
const applicationID = import.meta.env.VITE_NEWRELIC_APPLICATION_ID ?? ""
const releaseTag = import.meta.env.VITE_RELEASE_TAG ?? ""

if (applicationID) {
  const options = {
    init: {
      distributed_tracing: {
        enabled: true
      },
      privacy: {
        cookies_enabled: true
      },
      ajax: {
        deny_list: ["bam.nr-data.net"]
      }
    },
    loader_config: {
      accountID: accountID,
      trustKey: trustKey,
      agentID: agentID,
      licenseKey: licenseKey,
      applicationID: applicationID
    },
    info: {
      beacon: "bam.nr-data.net",
      errorBeacon: "bam.nr-data.net",
      licenseKey: licenseKey,
      applicationID: applicationID,
      sa: 1
    }
  }

  const nrAgent = new BrowserAgent(options)
  nrAgent.addRelease("release", releaseTag)
  nrAgent.setApplicationVersion(releaseTag)
  nrAgent.start()

  const originalConsoleError = console.error
  console.error = function (...args: unknown[]) {
    originalConsoleError.apply(console, args)

    const errorMessage = args
      .map(arg => {
        if (typeof arg === "object") {
          try {
            return JSON.stringify(arg)
          } catch (_e) {
            return String(arg)
          }
        }
        return String(arg)
      })
      .join(" ")

    nrAgent.noticeError(new Error(`Console Error: ${errorMessage}`), {
      custom: {
        consoleArgs: args,
        timestamp: new Date().toISOString(),
        releaseTag: releaseTag
      }
    })
  }
}
